import { configureTelemetry } from '@ms/yammer-telemetry';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';

import config from '../../config';

export const configure = (): Promise<void> => {
  configureTelemetry({
    config,
    telemetryClientId: config.application.applicationId,
    hostingConfig: readHostingConfiguration(),
    skipNextCleanup: true,
    registerUnhandledEventsListener: true,
    isMsal: true,
  });

  return Promise.resolve();
};
